import Badge from "@mui/material/Badge";
import { ActionsMenu } from "../components/utils/ActionsMenu";

export function getIngredientsDataGridColumns(t) {
  const columns = [
    {
      field: "code",
      headerName: t("dashboard.table.label.code"),
      width: 100,
    },
    {
      field: "technofunctionality",
      headerName: t("dashboard.table.label.technofunctionality"),
      width: 350,
    },
    {
      field: "ingredient",
      headerName: t("dashboard.table.label.ingredient"),
      width: 350,
    },
    {
      field: "sourceCategory",
      headerName: t("dashboard.table.label.sourceCategory"),
      width: 200,
    },
    {
      field: "sector",
      headerName: t("dashboard.table.label.sector"),
      width: 200,
    },
    {
      field: "productPlatform",
      headerName: t("dashboard.table.label.productPlatform"),
      width: 200,
    },
  ];

  return columns;
}

export function getUsersDataGridColumns(t) {
  const columns = [
    {
      field: "firstName",
      headerName: t("admin-dashboard.users.table.label.firstName"),
      width: 300,
    },
    {
      field: "lastName",
      headerName: t("admin-dashboard.users.table.label.lastName"),
      width: 300,
    },
    {
      field: "email",
      headerName: t("admin-dashboard.users.table.label.email"),
      width: 300,
    },
    {
      field: "role",
      headerName: t("admin-dashboard.users.table.label.role"),
      width: 200,
    },
    {
      field: "subscribed",
      headerName: t("admin-dashboard.users.table.label.subscribed"),
      width: 200,
      renderCell: (params) => {
        const status = params.value; // Assuming 'status' field contains the boolean value
        return (
          <Badge
            color={status ? "success" : "error"}
            badgeContent={status ? "Subscribed" : "Not Subscried"}
            sx={{ marginLeft: "40px" }}
          >
            ""
          </Badge>
        );
      },
    },
    {
      field: "activated",
      headerName: t("admin-dashboard.users.table.label.activated"),
      width: 200,
      renderCell: (params) => {
        const status = params.value; // Assuming 'status' field contains the boolean value
        return (
          <Badge
            color={status ? "success" : "error"}
            badgeContent={status ? "Activated" : "Deactivated"}
            sx={{ marginLeft: "40px" }}
          >
            ""
          </Badge>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 90,
      renderCell: (params) => <ActionsMenu rowData={params.row} />,
    },
  ];

  return columns;
}
